<template>
<div>
    <b-row class="pt-4">
      <b-col>
        <h3>Information</h3>
      </b-col>
    </b-row>
    <div v-if="statusMessage" class="pt-4">
        <b-alert sm="6" show variant="warning">
            <p>{{statusMessage}}</p>
        </b-alert>
    </div>
</div>
</template>

<script>
export default {
mixins: [],
props: [],
data() { return {}},
computed: {
    url: function () {
    let urls = this.$store.getters.getUrlsList;
    return urls[process.env.VUE_APP_WHERE].json;
  },
  statusMessage: function () {
      let status = this.$store.getters.getStatus;
      let message = "";

      switch (status) {
          case 1:
            message = this.$t('info.noUserToken');
            break;
          case 2:
            message = this.$t('info.linkExpired');
            break;
          case 3:
            message = this.$t('info.endorserClosed');
            break;
          default:
            message = this.$t('info.errorgeneric');
      }

      return message;
  },
  endorserData: function () {
    return this.$store.getters.getEndorserData;
  }
},
methods:{},
components: {}
}
</script>